import axios from "axios";
import * as types from "../mutation-types";
import "moment/dist/locale/de";
import moment from "moment/min/moment-with-locales";
import logger from "~/utilities/logger";

// state
export const state = {
  booking_list: [],
  recent_booking_list: null,
  recent_booked_projects: null,
  recent_booked_activities: null,
  selected_booking: null,
  filtered_proj_list: null,
  filtered_act_list: null,
  org_overview: null,
  orgs_booking_stats: null,
  orgs_overview: null,
  org_individual_overview: [],
  org_user_individual_overview: [],
};

// getters
export const getters = {
  booking_list: (state) => state.booking_list,
  org_overview: (state) => state.org_overview,
  orgs_booking_stats: (state) => state.orgs_booking_stats,
  orgs_overview: (state) => state.orgs_overview,
  org_individual_overview: (state) => state.org_individual_overview,
  org_user_individual_overview: (state) => state.org_user_individual_overview,
  recent_booking_list: (state) => state.recent_booking_list,
  recent_booked_projects: (state) => state.recent_booked_projects,
  recent_booked_activities: (state) => state.recent_booked_activities,
  selected_booking: (state) => state.selected_booking,
  filtered_proj_list: (state) => state.filtered_proj_list,
  filtered_act_list: (state) => state.filtered_act_list,
  check_list: (state) => state.booking_list !== null,
  check_recent_list: (state) => state.recent_booking_list !== null,
  check_recent_projects: (state) => state.recent_booked_projects !== null,
  check_recent_activities: (state) => state.recent_booked_activities !== null,
};

// mutations
export const mutations = {
  [types.FETCH_BOOKINGS](state, { booking_list })
  {
    return (state.booking_list = booking_list);
  },

  [types.FETCH_RECENT_BOOKED_PROJECTS](state, { list })
  {
    return (state.recent_booked_projects = list);
  },

  [types.FETCH_USER_BOOKINGS](state, { booking_list })
  {
    return (state.booking_list = booking_list);
  },

  [types.FETCH_RECENT_BOOKINGS](state, payload)
  {
    state.filtered_proj_list = payload.filtered_proj_list;
    state.filtered_act_list = payload.filtered_act_list;
    return (state.recent_booking_list = payload.recent_booking_list);
  },
  [types.FETCH_RECENT_BOOKINGS_FAILURE](state)
  {
    logger.error("FETCH_RECENT_BOOKINGS_FAILURE");
  },

  [types.FETCH_BOOKINGS_FAILURE](state)
  {
    logger.error("FETCH_BOOKINGS_FAILURE");
  },

  [types.UPDATE_BOOKING](state, booking) {},

  [types.FETCH_ORG_OVERVIEW](state, payload)
  {
    return (state.org_overview = payload);
  },

  [types.FETCH_ORGS_MONTHLY_OVERVIEW](state, payload)
  {
    return (state.orgs_overview = payload);
  },

  [types.FETCH_ORG_MONTHLY_INDIVIDUAL_OVERVIEW](state, payload)
  {
    return (state.org_individual_overview = payload);
  },

  [types.FETCH_ORGS_BOOKING_STATS](state, payload)
  {
    return (state.orgs_booking_stats = payload);
  },

  [types.FETCH_ORG_USER_MONTHLY_INDIVIDUAL_OVERVIEW](state, payload)
  {
    return (state.org_user_individual_overview = payload);
  },
};

// actions
export const actions = {
  async getBookings({ commit }, options)
  {
    let paginate = options && options.paginate ? options.paginate : 10000;
    let extraOptions =
      options && options.extra_options ? options.extra_options : "";

    try
    {
      logger.log("store.getBookings");

      const { data } = await axios.get(
        `/api/bookings?paginate=${paginate}${extraOptions}`
      );

      logger.log("store.getBookings rsp", data);

      return commit(types.FETCH_BOOKINGS, { booking_list: data?.data?.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_BOOKINGS_FAILURE);
    }
  },

  async getOrgBookingStats({ commit }, payload = {})
  {
    const ids = payload.org_ids;
    if (!ids) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_payload || "";
    const selected_date_min =
      payload?.selected_date_min || moment().format("DD.MM.yyyy");

    const theMonth = moment(selected_date_min, "DD.MM.yyyy").month() + 1; // jan=0, dec=11
    const theYear = moment(selected_date_min, "DD.MM.yyyy").year();

    const url = `/api/organization/booking_stats/${ids}/${theYear}/${theMonth}?paginate=${paginate}${extraOptions}`;

    try
    {
      logger.log("store.getOrgBookingStats");

      const { data } = await axios.get(url);

      logger.log("store.getOrgBookingStats rsp", data);

      return commit(types.FETCH_ORGS_BOOKING_STATS, data?.data);
    } catch (e)
    {
      logger.log(e);
      logger.error("getOrgBookingStats error", e);
      // return commit(types.FETCH_BOOKINGS_FAILURE);
    }
  },

  async updateBooking({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(
        `/api/bookings/${payload.pro_id}`,
        payload
      );

      return commit(types.UPDATE_BOOKING, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.UPDATE_BOOKING_FAILURE, { error: e });
    }
  },

  async getUserRecentProjects({ commit, dispatch }, payload)
  {
    const id = payload.usr_id;
    if (!id) return;

    const paginate = payload?.paginate || 5;
    const extraOptions = payload?.extra_options || "";
    const url = `/api/bookings/recent/projects/${id}${extraOptions}`;

    try
    {
      const { data } = await axios.get(url);

      if (data?.status !== "success") throw "Error";

      const booked_project_list =
        data.data?.map((project) => project?.project) || [];

      logger.log("store.getUserRecentProjects exit", booked_project_list);

      return commit(types.FETCH_RECENT_BOOKED_PROJECTS, {
        list: booked_project_list,
      });
    } catch (e)
    {
      logger.log("store.getUserRecentProjects", e);
    }
  },

  async getUserRecentBookings({ commit, dispatch }, payload)
  {
    const id = payload?.usr_id;
    if (!id) return;

    const paginate = payload?.paginate || 5;
    const extraOptions = payload?.extra_options || "";

    const url = `/api/bookings/recent/${id}?paginate=${paginate}${extraOptions}`;

    try
    {
      logger.log("store.getUserRecentBookings");
      const { data } = await axios.get(url);

      if (data?.status !== "success") throw "Error";

      logger.log("store.getUserRecentBookings rsp", data);

      const recent_booking_list = data?.data || [];
      const filtered_proj_list = data?.recent_projects || [];
      const filtered_act_list = data?.recent_activities || [];

      return commit(types.FETCH_RECENT_BOOKINGS, {
        recent_booking_list,
        filtered_proj_list,
        filtered_act_list,
      });
    } catch (e)
    {
      logger.log("store.getRecentBookings", e);
    }
  },

  async getUserBookings({ commit, dispatch }, payload)
  {
    const id = payload?.usr_id;
    if (!id) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";

    const selected_date_min =
      payload?.selected_date_min || moment().format("DD.MM.yyyy");
    const theMonth = moment(selected_date_min, "DD.MM.yyyy").month() + 1; // jan=0, dec=11
    const theYear = moment(selected_date_min, "DD.MM.yyyy").year();

    const url = `/api/booking/user/${id}/${theYear}/${theMonth}?paginate=${paginate}${extraOptions}`;
    try
    {
      logger.log("store.getUserBookings", url);

      const { data } = await axios.get(url);

      if (data?.status !== "success") throw data;

      logger.log("store.getUserBookings rsp", data);

      return commit(types.FETCH_USER_BOOKINGS, { booking_list: data.data });
    } catch (e)
    {
      logger.error("store.getUserBookings error", e);
      return commit(types.FETCH_USER_BOOKINGS_FAILURE, e);
    }
  },

  async getOrganizationOverview({ commit, dispatch }, payload)
  {
    const id = payload?.org_id;
    if (!id) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";

    const selected_date_min =
      payload?.selected_date_min || moment().format("DD.MM.yyyy");
    const theMonth = moment(selected_date_min, "DD.MM.yyyy").month() + 1; // jan=0, dec=11
    const theYear = moment(selected_date_min, "DD.MM.yyyy").year();

    const url = `/api/booking/organization/overview/${id}/${theYear}/${theMonth}${extraOptions}`;

    try
    {
      logger.log("store.getOrganizationsOverview", id);

      const { data } = await axios.get(url);

      logger.log("store.getOrganizationsOverview rsp", data);

      if (data?.status !== "success") throw data;

      return commit(types.FETCH_ORG_OVERVIEW, data.data);
    } catch (e)
    {
      logger.error("store.getOrganizationsOverview error", e);
      return commit(types.FETCH_ORG_OVERVIEW_FAILURE);
    }
  },

  async getOrgsMonthlyOverview({ commit, dispatch }, payload)
  {
    const ids = payload?.org_ids;
    if (!ids) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";

    const selected_date_min =
      payload?.selected_date_min || moment().format("DD.MM.yyyy");
    const theMonth = moment(selected_date_min, "DD.MM.yyyy").month() + 1; // jan=0, dec=11
    const theYear = moment(selected_date_min, "DD.MM.yyyy").year();

    const url = `/api/organization/monthly/${ids}/${theYear}/${theMonth}?paginate=${paginate}${extraOptions}`;

    try
    {
      logger.log("store.getOrgsMonthlyOverview", url);

      const { data } = await axios.get(url);

      logger.log("store.getOrgsMonthlyOverview rsp", data);

      if (data?.status !== "success") throw data;

      return commit(types.FETCH_ORGS_MONTHLY_OVERVIEW, data.data);
    } catch (e)
    {
      logger.error("store.getOrgsMonthlyOverview error", e);
      return commit(types.FETCH_ORGS_MONTHLY_OVERVIEW_FAILURE, e);
    }
  },

  async getOrgMonthlyIndividualOverview({ commit, dispatch }, payload)
  {
    const ids = payload?.org_ids;
    if (!ids) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";

    const selected_date_min =
      payload?.selected_date_min || moment().format("DD.MM.yyyy");
    const theMonth = moment(selected_date_min, "DD.MM.yyyy").month() + 1; // jan=0, dec=11
    const theYear = moment(selected_date_min, "DD.MM.yyyy").year();

    const url = `/api/organization/monthly/individual/${ids}/${theYear}/${theMonth}?paginate=${paginate}${extraOptions}`;
    try
    {
      logger.log("store.getOrgsMonthlyIndividualOverview", url);

      const { data } = await axios.get(url);

      if (data?.status !== "success") throw data;

      logger.log("store.getOrgsMonthlyIndividualOverview rsp", data);

      return commit(types.FETCH_ORG_MONTHLY_INDIVIDUAL_OVERVIEW, data.data);
    } catch (e)
    {
      logger.error("store.getOrgsMonthlyIndividualOverview error", e);
      // commit(types.FETCH_ORG_MONTHLY_INDIVIDUAL_OVERVIEW_FAILURE, e);
    }
  },

  async getOrgUserMonthlyIndividualOverview({ commit, dispatch }, payload)
  {
    const org_id = payload?.org_id;
    const id = payload?.usr_id;

    if (!org_id || !id) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";

    const selected_date_min =
      payload?.selected_date_min || moment().format("DD.MM.yyyy");
    const theMonth = moment(selected_date_min, "DD.MM.yyyy").month() + 1; // jan=0, dec=11
    const theYear = moment(selected_date_min, "DD.MM.yyyy").year();

    const url = `/api/organization/monthly/individual/${org_id}/${id}/${theYear}/${theMonth}?paginate=${paginate}${extraOptions}`;

    try
    {
      logger.log("store.getOrgUserMonthlyIndividualOverview", url);

      const { data } = await axios.get(url);

      if (data?.status !== "success") throw data;

      logger.log("store.getOrgUserMonthlyIndividualOverview rsp", data);

      return commit(
        types.FETCH_ORG_USER_MONTHLY_INDIVIDUAL_OVERVIEW,
        data.data
      );
    } catch (e)
    {
      logger.error("store.getOrgUserMonthlyIndividualOverview error", e);
      // commit(types.FETCH_ORG_USER_MONTHLY_INDIVIDUAL_OVERVIEW_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
